import React, { useState, useRef, useEffect } from 'react';
import { History } from 'history';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { SelectList } from 'components/ui/SelectList/SelectList';
import { useInjection } from 'services/ioc/ioc.react';
import { AutosaveStore } from 'stores/AutosaveStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import SavedSessionModal from 'components/modals/SavedSessionModal/SavedSessionModal';
import { Control, MeatBallsWrapper } from './styles/MeatBallsStyles';
import { ReactComponent as RightIcon } from 'components/icons/rightIcon.svg';
import { ReactComponent as PencilIcon } from './icons/pencilIcon.svg';
import { ReactComponent as SettingsIcon } from './icons/settingsIcon.svg';
import { ReactComponent as MergeIcon } from './icons/mergeIcon.svg';

interface IProps {
  sessionId: string;
  history: History;
  id: number;
}

export const MeatBalls: React.FC<IProps> = (props) => {
  const { sessionId, history, id } = props;
  const ref = useRef<any>();
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const autosaveStore = useInjection<AutosaveStore>(ServiceTypes.AutosaveStore);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { sessionId: savedSessionId } = autosaveStore.load();

  useOnClickOutside(ref, () => setIsMenuVisible(false));

  const editSessionHandler = () => {
    if (savedSessionId === '' || sessionId === savedSessionId) {
      history.push(`/edit/sessionId/${sessionId}`);
    } else {
      setIsModalVisible(true);
    }
  };

  const sessionSettingsHandler = () => {
    if (savedSessionId === '' || sessionId === savedSessionId) {
      history.push(`/settings/sessionId/${sessionId}`);
    }
  };

  const mergeSessionHandler = () => {
    history.push(`/merge/sessionId/${sessionId}`);
  };

  const handleOnClickMeatBalls = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  return (
    <MeatBallsWrapper ref={ref} onClick={handleOnClickMeatBalls} data-test={`meatball-${id}`}>
      <RightIcon />
      <SelectList visible={isMenuVisible} padding='4px' top='25px' right='-40px'>
        <Control onClick={editSessionHandler} data-test={`edit-session-${id}`}>
          <PencilIcon />
          Edit
        </Control>
        <Control onClick={sessionSettingsHandler} data-test={`session-settings-${id}`}>
          <SettingsIcon />
          Session settings
        </Control>
        <Control onClick={mergeSessionHandler} data-test={`merge-session-${id}`}>
          <MergeIcon />
          Merge with this as master
        </Control>
      </SelectList>
      <SavedSessionModal
        isModalVisible={isModalVisible}
        savedSessionId={savedSessionId}
        sessionId={sessionId}
        setIsModalVisible={setIsModalVisible}
        history={history}
      />
    </MeatBallsWrapper>
  );
};
